module.exports = __webpack_public_path__ + "media/images/reports/info-240869cbd02d674abc5fd9a429a798be.svg";